export default __webpack_public_path__ + "38107b5.png";